import { ItemCardWithPieces } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardWithPieces/ItemCardWithPieces";
import { ItemWithPieces } from "@coworker/apprestructured/src/shared/types/item";
import { ItemNoAndTypeWithPTagsOrdered } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { FixaQuantityStepper } from "@coworker/apprestructured/src/shared/wrappers/FixaQuantityStepper/FixaQuantityStepper";
import { Loading } from "../../../loading";
import React from "react";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./ArticlesPrintPtagsQuantityContent.module.css";
import { useTranslation } from "@coworker/locales";

interface ArticlesPrintPtagsQuantityContentProps {
  itemsWithPieces: ItemWithPieces[];
  itemNosAndTypeWithOrderedDetails:
    ItemNoAndTypeWithPTagsOrdered[] | null | Loading;
  onPrintPtagsQuantityChange: (
    itemNo: string,
    newPrintPtagsQuantity: number
  ) => void;
}

export const ArticlesPrintPtagsQuantityContent = ({
  itemsWithPieces,
  itemNosAndTypeWithOrderedDetails,
  onPrintPtagsQuantityChange,
}: ArticlesPrintPtagsQuantityContentProps) => {
  const { t } = useTranslation();

  const pTagsByItemNo = new Map(
    Array.isArray(itemNosAndTypeWithOrderedDetails)
      ? itemNosAndTypeWithOrderedDetails.map(
          ({ no, pieces, ptags_ordered }) => [
            no,
            { pieces, ordered_quantity: ptags_ordered.quantity },
          ]
        )
      : []
  );

  return (
    <>
      {itemsWithPieces.map((item) => {
        const itemPTags = pTagsByItemNo.get(item.no);
        const orderedPTags = itemPTags?.ordered_quantity ?? 0;
        const maxPTags = itemPTags?.pieces ?? 0;

        return (
          <React.Fragment key={item.no}>
            <ItemCardWithPieces item={item} />
            <div className={styles["stepper"]}>
              <FixaQuantityStepper
                small
                fluid
                defaultValue={orderedPTags}
                ariaDescribedById={`item-print-ptags-quantity-stepper-${item.no}`}
                ariaDescribedBy={`print-ptags-quantity-stepper-${item.no}`}
                minVal={orderedPTags === 0 ? 0 : 1}
                maxVal={maxPTags}
                disabled={orderedPTags === 0}
                onQuantityChange={(newQuantity) =>
                  onPrintPtagsQuantityChange(item.no, Number(newQuantity))
                }
              />
            </div>
            <div className={styles["checkboxSection"]}>
              <FixaText tagName="p" textStyle="Body.M">
                {t("noPtagsNeededString")}
              </FixaText>
              <FixaCheckbox
                onChange={() =>
                  onPrintPtagsQuantityChange(
                    item.no,
                    orderedPTags > 0 ? 0 : maxPTags
                  )
                }
                checked={orderedPTags === 0}
                value={item.no}
                id={`item-print-ptags-checkbox-${item.no}`}
              />
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
};
